import React from "react"

class OrderComplete extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      window.location.href = this.props.orderCompleteUrl;
    }, 2000);
  }

  render() {
    return (
      <div className="container single-page-checkout">
        <div className="row-fluid">
          <div className="span12">
            <div className="order-complete">
              <div className="order-content">
                <h1>Completing your Order...</h1>
                <div className="loader" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderComplete;
